import { createContext, useContext, useState, useEffect } from "react";
import { api } from "../lib/utils";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchUser = async () => {
    try {
      const response = await api.get(`/api/auth/me`);
      setUser(response.data);
    } catch (error) {
      console.error("Failed to fetch user:", error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await api.post(`/api/auth/login`, { email, password });
    const { token: newToken, user: userData, session_id } = response.data;
    localStorage.setItem("token", newToken);
    if (session_id) {
      localStorage.setItem("session_id", session_id);
    }
    setToken(newToken);
    setUser(userData);
    return userData;
  };

  const logout = async () => {
    // Call backend logout to record session duration
    try {
      await api.post(`/api/auth/logout`);
    } catch (error) {
      console.error("Logout API error:", error);
    }
    localStorage.removeItem("token");
    localStorage.removeItem("session_id");
    setToken(null);
    setUser(null);
  };

  const isAdmin = user?.role === "admin";

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
